// 优先保障对象
export const priorityTypes = [
    { value: 'FIRST', text: '1、政府供养保障对象：城市特困人员。（由区（县）民政部门认定）' },
    {
        value: 'SECOND',
        text: ' 2、困境家庭保障对象：包括低保或低收入家庭中孤寡、失能、半失能等特殊困难人员。（由区（县）民政部门认定）',
    },
    {
        value: 'THIRD',
        text: '3、优待服务保障对象：包括享受市级及以上劳动模范待遇人员、因公致残人员或见义勇为伤残人士、退役军人等为社会作出突出贡献人员。',
    },
    {
        value: 'FOURTH',
        text: '4、计划生育特殊家庭老年人（失独老人）。',
    },
    { value: 'FIIVE', text: '5、遗体和人体器官（组织）捐献者的父母、配偶。' },
];
